export default {
  dbu_year_report_title: 'Annual Review 2025',
  dbu_year_report_menu_title: 'Annual Review 2025',
  dbu_year_report_loading: 'Loading...',
  dbu_year_report_load_error: 'Failed to load page, please try again later',
};
